import React from 'react';
import ScenariosTab from '../components/Scenarios';

export default function Scenarios() {
  return <ScenariosTab />;
}
